import type { PermissionModel } from './model';
import type { PermissionLevel, PermissionType } from './permission-types';

const GRANTED: readonly PermissionLevel[] = ['OnlyMine', 'MyGroups', 'All'];

const CRUD_KEYS = {
  Read: 'readPermission',
  Create: 'createPermission',
  Update: 'updatePermission',
  Delete: 'deletePermission',
} as const;

/**
 * Checagem **fail-closed** do catálogo do agente (09 §5.3, D03/GU-17): o recurso precisa estar no
 * modelo, o nível CRUD precisa existir, ser diferente de `None` e estar na faixa, e a ação só vale no
 * próprio recurso (`strict`). As telas oficiais continuam no `can()` fiel ao legado (U37-1).
 */
export function canForCatalog(model: readonly PermissionModel[] | undefined, resource: string, type: PermissionType): boolean {
  const entry = model?.find((perm) => perm.resource === resource);
  if (!entry) return false;
  if (Object.hasOwn(CRUD_KEYS, type)) {
    const level = entry[CRUD_KEYS[type as keyof typeof CRUD_KEYS]];
    return level !== undefined && GRANTED.includes(level);
  }
  return entry.actions?.[type] === true;
}
